// @flow
import { handleActions } from 'redux-actions';

import {
  GET_DOGS,
  GET_DOGS_SUCCESS,
  GET_DOGS_FAILURE,
} from '../../actions/actionTypes';

const initialState = {
  dogs: [],
};

const dogsSuccessParser = (data) => {
  const dogs = data.map(dog => (
    {
      id: dog.id,
      breed: dog.breed,
      imageUrl: dog.image_url,
      name: dog.name,
      notes: dog.likes,
      sterile: dog.sterile,
      veterinarians: dog.veterinarians,
    }
  ));
  return dogs;
};

export const dogs = handleActions(
  {
    [GET_DOGS]: state => (
      {
        ...state,
      }
    ),
    [GET_DOGS_SUCCESS]: (state, {
      payload: {
        data,
      },
    }) => (
      {
        ...state,
        dogs: dogsSuccessParser(data),
      }
    ),
    [GET_DOGS_FAILURE]: state => (
      {
        ...state,
      }
    ),
  },
  initialState,
);
